import { Injectable } from '@angular/core';
import { CommunicationConfigurationEmailSenderModel } from '../entity/communicationConfigurationEmailSender.model';
import { CommunicationConfigurationEmailSenderSummaryModel } from '../entity/communicationConfigurationEmailSenderSummary.model';
import { CommunicationConfigurationEmailSenderRepository } from '../../impl/service/repository/communicationConfigurationEmailSender.repository';
import { CommunicationConfigurationEmailSenderSummaryDataServiceAdapter } from '../../impl/service/repository/communicationConfigurationEmailSenderSummary.dataserviceadapter';
import { AbstractFindAllService } from 'src/app/modules/core/service/v2/service/findAll/abstractFindAll.service';

@Injectable()
export class CommunicationConfigurationEmailSenderSummaryFindAllService extends AbstractFindAllService<CommunicationConfigurationEmailSenderModel, CommunicationConfigurationEmailSenderSummaryModel> {
    constructor(
        repository: CommunicationConfigurationEmailSenderRepository,
        serviceAdapter: CommunicationConfigurationEmailSenderSummaryDataServiceAdapter
    ) {
        super(repository, serviceAdapter);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}